import Sidebar from "../layout/component/sidebar/Sidebar"
import TopBar from "../layout/component/topbar/TopBar"
import { useSidebarCollapse } from "../layout/component/sidebar/useSidebarCollapse"
import { Outlet } from "react-router-dom"
import { Suspense } from "react"
import SuspenseLoader from "../helper/loader/SuspenseLoader"

const COLLAPSED_WIDTH_PX = 80
const EXPANDED_WIDTH_PX = 240

const shellStyle = {
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
}

const bodyRowStyle = {
  display: "flex",
  flex: 1,
  minHeight: 0,
}

const sidebarStyle = (width) => ({
  width,
  flexShrink: 0,
  transition: "width 0.2s ease",
})

const contentStyle = {
  flex: 1,
  minWidth: 0,
  padding: 24,
}

const DefaultLayout = () => {
  const { collapsed, toggle } = useSidebarCollapse()
  const sidebarWidth = collapsed ? COLLAPSED_WIDTH_PX : EXPANDED_WIDTH_PX

  return (
    <div style={shellStyle}>
      <TopBar collapsed={collapsed} onToggle={toggle} />
      <div style={bodyRowStyle}>
        <div style={sidebarStyle(sidebarWidth)}>
          <Sidebar collapsed={collapsed} />
        </div>
        <main style={contentStyle}>
          <Suspense fallback={<SuspenseLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  )
}

export default DefaultLayout
